export default __webpack_public_path__ + "static/media/gps-icon.05741c97.svg";